import { Batch } from '../../batches/models';

export class Invoice {
  public id: number;
  public created_at: string;
  public updated_at: string;
  public lists: Batch[];
  public batch_numbers?: string[];
  public committed?: boolean;
  public serial_number: number;
  public selected?: boolean;

  constructor(data: Invoice) {
    data.batch_numbers = data.lists.map((el) =>
      el.name.slice(el.name.indexOf('№'))
    );
    Object.assign(this, data);
  }
}

export type InvoiceFileType = 'pdf' | 'xlsx';

export interface CreateInvoiceBody {
  lists: number[];
}

export interface DownloadInvoiceParams {
  type: InvoiceFileType;
}
